import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'hooks';

import { FullPageLoader } from '~components';

import { selectUserTags } from '~main/selectors/login';

interface ComponentProps {
  Route: React.FC;
  authTag: string;
  redirect?: string;
  [key: string]: any;
}

const AppAuthTagRoute: React.FC<ComponentProps> = ({ Route, authTag, redirect = '/home', ...props }) => {
  const [isLoading, setIsLoading] = useState(true);

  const tags = useAppSelector(selectUserTags);

  const checkAccess = () => {
    const hasAccess = !authTag || (authTag && tags.includes(authTag));

    if (hasAccess) setIsLoading(false);
    else window.location.replace(redirect);
  };

  useEffect(() => {
    checkAccess();
  }, []);

  return (
    <>
      <FullPageLoader isLoading={isLoading} />
      {!isLoading && <Route {...props} />}
    </>
  );
};

export default AppAuthTagRoute;
